<template>
  <b-modal ref="modal" hide-footer centered title="Create Workflow" v-b-modal.modal-xl>
    <b-form @submit.prevent="save">
      <b-form-group label="Name:">
        <b-form-input
          v-model.trim="$v.name.$model"
          :class="{ 'is-invalid': $v.name.$error }"
          :disabled="inProcess"
        />
        <b-form-invalid-feedback v-if="!$v.name.required">Name is required</b-form-invalid-feedback>
      </b-form-group>
      <div>
        <b-button variant="success" type="submit">Save</b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
// services
import db from '@/services/db'

export default {
  data() {
    return {
      name: null,
      inProcess: false,
    }
  },
  methods: {
    open() {
      if (this.$refs.modal) this.$refs.modal.show()
    },
    close() {
      if (this.$refs.modal) this.$refs.modal.hide()
    },
    save() {
      if (this.inProcess) return
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.inProcess = true

      this.$store.commit('addProcess', {
        process: 'newDataGrid',
        message: 'Creating',
      })

      db.workflow.create(this.name, key => {
        const name = this.name

        this.$store.commit('deleteProcess', 'newDataGrid')
        this.name = null
        this.inProcess = false
        this.$nextTick(() => {
          this.$v.$reset()
        })
        this.close()

        this.$emit('created', key, { name })
      })
    },
  },
  validations: {
    name: {
      required,
    },
  },
}
</script>
